import React, { useState } from "react"

import { useBranches, branchTypes as _branchTypes, targetTypes, configuration as _configuration } from '../../../../hooks/api/useBranches';

import {
    initialValues as _initialValues,
    validationSchema as _validationSchema,
    branchDataTypes as _branchDataTypes,
    customInjectionProps as _branchInjectionProps,
    customInjectionFields as _branchInjectionFields
} from "../../schema/user/branchSchema"

// import {
//     useInjectionProps,
//     propTypes as injectionPropTypes,
//     propRefs as injectionPropRefs,
//     propFieldTypes as injectionPropFieldTypes,
//     targetTypes as injectionPropTargetTypes,
// } from "../../../../hooks/api/useInjectionProps"

import {
    useInjectionFields,
    scopeTypes as injectionFieldScopeTypes,
} from "../../../../hooks/api/useInjectionFields"

import { getInjectionDataType } from "../../utils/injectionSelection";

export const markingInjectionProps = _branchInjectionProps
export const markingInjectionFields = _branchInjectionFields
export const initialValues = _initialValues
export const validationSchema = _validationSchema
export const branchDataTypes = _branchDataTypes
export const branchTypes = _branchTypes

export function useMarking({
    jwtToken: _jwtToken,
    routeType: _routeType
}) {

    const [routeType, setRouteType] = useState(_routeType)

    const { isLoading, get, list, create, update, filterOperatorTypes } = useBranches({
        branchType: branchTypes.customer,
        targetType: targetTypes.customer
    })

    // const { create: createInjectionProps } = useInjectionProps({
    //     propType: injectionPropTypes.user.customer.id,
    //     targetType: injectionPropTargetTypes.user.id,
    // });

    const { getUpdateFieldValuesPayload, updateFieldValues } = useInjectionFields({
        scopeType: injectionFieldScopeTypes.branch.id
    });

    // list markings
    const listMarkings = async ({
        props,
        status: _status,
        customerUserId: _customerUserId = '',
        markingIds: _markingIds = [],
        markingKeyword: _markingKeyword = '',
        dataTypes: _dataTypes = [`${getInjectionDataType('customer_branch')}`],
        disableServerClientCancellation = false
    }) => {

        props.dataTypes = _dataTypes

        if (disableServerClientCancellation === false) {
            props.configuration = {
                [_configuration.enableServerClientCancellation.id]: true
            }
        }

        let filterValues = [
        ]

        if (_status !== '') {
            filterValues = [...filterValues, ...[
                {
                    name: `status`,
                    operator: filterOperatorTypes.eq,
                    value: _status
                }
            ]]
        }

        if (_customerUserId !== '') {
            filterValues = [...filterValues, ...[
                {
                    name: `user_id`,
                    operator: filterOperatorTypes.eq,
                    value: _customerUserId
                }
            ]]
        }

        if (_markingKeyword !== '') {
            filterValues = [...filterValues, ...[
                {
                    name: `${markingInjectionProps.marking.retrieveKey}`,
                    operator: filterOperatorTypes.contains,
                    value: encodeURIComponent(_markingKeyword)
                }
            ]]
        }

        if (_markingIds.length > 0) {
            filterValues = [...filterValues, ...[
                {
                    name: `id`,
                    operator: filterOperatorTypes.anyOf,
                    value: JSON.stringify(_markingIds)
                }
            ]]
        }

        if (props?.filterValue) {
            props.filterValue = [...props.filterValue, ...filterValues]
        } else {
            props.filterValue = filterValues
        }

        const result = await list(props)

        let data = result?.data?.branches ? result.data.branches : []

        return {
            data,
            // count: result?.data?.nofilter_total
            count: result?.data?.total
        }

    }

    // done
    // add marking
    const addMarking = async ({
        customerUserId: _customerUserId = '',
        marking: _marking = '',
        branch: _branch = {
            branchName: '',
            branchCode: '',
            branchContact: '',
            branchEmail: '',
            type: '',
            address1: '',
            address2: "",
            countryId: "",
            stateId: '',
            areaId: '',
            postcode: '',
            remark: '',
            picName: '',
            picContact: '',
            picEmail: '',
            isHQ: '',
            status: ''
        }
    }) => {

        let data = {
            branch: {
                branch_name: _branch?.branchName,
                branch_code: _branch?.branchCode,
                branch_contact: _branch?.branchContact,
                branch_email: _branch?.branchEmail,
                type: _branch?.type,
                address_1: _branch?.address1,
                address_2: _branch?.address2,
                country_id: _branch?.countryId,
                state_id: _branch?.stateId,
                area_id: _branch?.areaId,
                postcode: _branch?.postcode,
                remark: _branch?.remark,
                pic_name: _branch?.picName,
                pic_contact: _branch?.picContact,
                pic_email: _branch?.picEmail,
                is_hq: _branch?.isHQ ? 1 : 0,
                status: _branch?.status ? 1 : 0,
            },
            props: {
                marking: '',
            },
        };

        const response = await create({
            id: _customerUserId,
            data,
        });

        // let injectionProps = [
        //     {
        //         props_module: injectionPropTypes.branch.customer.id,
        //         props_ref: injectionPropTargetTypes.branch.id,
        //         ref_id: {
        //             [injectionPropRefs.branch.customer]: response?.data.branch.id,
        //         },
        //         props_key: markingInjectionProps.marking.submitKey,
        //         props_field: markingInjectionProps.marking.propFieldId,
        //         [markingInjectionProps.marking.propFieldName]: _marking,
        //         is_multiple: markingInjectionProps.marking.propIsMultiple,
        //     },
        // ];

        // let dataInjectionProps = {
        //     injection_props: injectionProps,
        // };

        // const responseInjectionProps = await createInjectionProps({ data: dataInjectionProps });

        // insert injection fields
        let dataInjectionFields = getUpdateFieldValuesPayload({
            items: [
                {
                    key: `${markingInjectionFields.marking.submitKey}`,
                    ref: `${markingInjectionFields.marking.ref}`,
                    module: `${markingInjectionFields.marking.module}`,
                    refId: `${response?.data.branch.id}`,
                    value: `${JSON.stringify(_marking)}`
                }
            ]
        })

        console.log('dataInjectionFields', dataInjectionFields)

        const responseInjectionFields = await updateFieldValues({ data: dataInjectionFields });

        return response

    }

    // get marking
    const getMarking = async ({
        id,
        dataTypesArray = [`${getInjectionDataType('customer_branch')}`]
    }) => {

        const result = await get({ id, dataTypesArray })

        let data = result?.data ? result.data : {}

        return data

    }

    // done
    // update marking
    const updateMarking = async ({
        customerUserId: _customerUserId = '',
        markingId: _markingId = '',
        marking: _marking = '',
        branch: _branch = {
            branchName: '',
            branchCode: '',
            branchContact: '',
            branchEmail: '',
            type: '',
            address1: '',
            address2: '',
            countryId: '',
            stateId: '',
            areaId: '',
            postcode: '',
            remark: '',
            picName: '',
            picContact: '',
            picEmail: '',
            isHq: '',
            status: '',
        }
    }) => {

        let data = {
            branch: {
                branch_name: _branch?.branchName,
                branch_code: _branch?.branchCode,
                branch_contact: _branch?.branchContact,
                branch_email: _branch?.branchEmail,
                type: _branch?.type,
                address_1: _branch?.address1,
                address_2: _branch?.address2,
                country_id: _branch?.countryId,
                state_id: _branch?.stateId,
                area_id: _branch?.areaId,
                postcode: _branch?.postcode,
                remark: _branch?.remark,
                pic_name: _branch?.picName,
                pic_contact: _branch?.picContact,
                pic_email: _branch?.picEmail,
                is_hq: _branch?.isHq ? 1 : 0,
                status: _branch?.status ? 1 : 0,
            },
            props: {
                marking: '',
            },
        };

        const response = await update({
            userId: _customerUserId,
            branchId: _markingId,
            data,
        });

        // let injectionProps = [
        //     {
        //         props_module: injectionPropTypes.branch.customer.id,
        //         props_ref: injectionPropTargetTypes.branch.id,
        //         ref_id: {
        //             [injectionPropRefs.branch.customer]: _customerUserId,
        //         },
        //         props_key: markingInjectionProps.marking.submitKey,
        //         props_field: markingInjectionProps.marking.propFieldId,
        //         [markingInjectionProps.marking.propFieldName]: _marking,
        //         is_multiple: markingInjectionProps.marking.propIsMultiple,
        //     },
        // ];

        // let dataInjectionProps = {
        //     injection_props: injectionProps,
        // };

        // const responseInjectionProps = await createInjectionProps({ data: dataInjectionProps });

        // insert injection fields
        let dataInjectionFields = getUpdateFieldValuesPayload({
            items: [
                {
                    key: `${markingInjectionFields.marking.submitKey}`,
                    ref: `${markingInjectionFields.marking.ref}`,
                    module: `${markingInjectionFields.marking.module}`,
                    refId: `${_customerUserId}`,
                    value: `${JSON.stringify(_marking)}`
                }
            ]
        })

        console.log('dataInjectionFields', dataInjectionFields)

        const responseInjectionFields = await updateFieldValues({ data: dataInjectionFields });

        return response

    }

    return {
        isLoading,
        filterOperatorTypes,
        listMarkings,
        getMarking,
        addMarking,
        updateMarking
    }
}